window.JSHINT = require('jshint').JSHINT
